import { getFetch } from '../fetch';
import { apiConfig } from '../config';

/** Настоящий тип в modules с тем же названием */
type TeacherReserveParticipant = unknown;

export function getTeacherReserveParticipant<T extends TeacherReserveParticipant>(): Promise<T> {
    const { apiGetTeacherReserveParticipant } = apiConfig.getStaticUrls();

    return getFetch(apiGetTeacherReserveParticipant);
}
